import { Component, inject } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../models/bary-modal-event';
import { BaryComponentHelper } from '../../../shared/util/bary-component-helper';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { TransportFormGroup } from '../../../../models/forms/TransportFormGroup';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-modal-use-registered-address',
  templateUrl: './modal-use-registered-address.component.html',
  styleUrls: ['./modal-use-registered-address.component.scss'],
})
export class ModalUseRegisteredAddressComponent {
  private readonly modalRef = inject(MDBModalRef);

  public transportForm!: TransportFormGroup;
  public isPickup!: boolean;
  public isLightEstimate = false;
  public icon = 'city';
  public iconClass = 'text-info';
  public title?: string;

  protected readonly FAS = FaDirectiveEnum.FAS;

  private action = BaryComponentHelper.generateAction<IBaryModalEvent>();

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  public submit(): void {
    this.action.next(new BaryModalEvent({ submit: true }));
    this.modalRef.hide();
  }
}
